/* eslint-disable no-empty-pattern */
import React from 'react'
import { Row, Col, Container } from 'reactstrap'
import RenderDataModal from '../RenderViewModal/RenderViewModal'
import { DataSearchResponseItemVersion } from '../../../../services/endpoints/data'
import './DataSpyFileSelectDialog.css'

export interface DataSpyFileSelectDialogProps {
  onClose: () => void
  versions: DataSearchResponseItemVersion[]
}
const DataSpyFileSelectDialog: React.FC<DataSpyFileSelectDialogProps> = ({ onClose, versions }) => {
  return (
    <RenderDataModal onClose={onClose} title='View with DataSpy'>
      <Container className="notes-container">
        <Row className="notes-row">
          <Col>
            DataSpy supports DB, DAT, and MF4 files. Select one of the available files to use.
            <div>
              {versions.map(i => {
                return <a
                  href={`/dataspy/?fileId=${i.id}`}
                  style={{ background: '#dff0d8' }}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div>{i.extension}</div>
                </a>
              })}
            </div>
          </Col>
        </Row>
      </Container>
    </RenderDataModal>
  )

}
export default DataSpyFileSelectDialog
